var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"status-bubble",class:_vm.status})])
}
var staticRenderFns = []

export { render, staticRenderFns }